<template>
  <div
    class="document"
    style="height: 100%"
  >
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Person ID Pending {{ properties['SYSTEM_LABEL-NEARMATCH'] }}(s/es)
          </div>
          <div class="header-subtitle">
            {{ nearMatches.length }} of {{ totalCount }} Pending {{ properties['SYSTEM_LABEL-NEARMATCH'] }}(s/es)
          </div>
        </template>
      </es-header>
    </div>
    <es-exception
      v-if="!totalCount"
      :exceptionMessage="`No Person Id Pending ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es).`"
    />
    <person-profile-pid-pending-near-match-overview-row
      v-else
      v-for="(nearMatch, index) in nearMatches"
      :key="index"
      :nearMatch="nearMatch"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import PersonProfilePidPendingNearMatchOverviewRow from '@/components/PersonProfilePidPendingNearMatchOverviewRow.vue';

library.add(
  faAngleDoubleRight,
);

export default {
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  components: {
    EsException,
    EsHeader,
    PersonProfilePidPendingNearMatchOverviewRow,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    nearMatches: {
      type: Array,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="css" scoped>
</style>
